import { Component, Input, Output, EventEmitter } from '@angular/core';
import { WorkbookStepbarService } from '../services/workbook-stepbar.service';
import { StepBarPayload, StepBarResponse } from '../modals/stepbar.models';

@Component({
  selector: 'app-wb-step-bar',
  templateUrl: './wb-step-bar.component.html',
  styleUrls: ['./wb-step-bar.component.scss']
})
export class WbStepBarComponent {
  @Input() workbookId: string;
  @Input() columnName: string | null = null; // Default column name for step bar
  @Input() steps: StepBarResponse[] = [];
  @Output() stepSelected = new EventEmitter<StepBarResponse>();

  selectedStep: string = 'All';

  constructor(private workbookStepbarService: WorkbookStepbarService) { }

  onStepClick(step: StepBarResponse) {
    this.selectedStep = step.name;
    this.stepSelected.emit(step);
  }

  isStepSelected(step: StepBarResponse): boolean {
    return this.selectedStep === step.name;
  }

} 